<template>
  <div class="flex items-center" :class="[ vertical ? 'px-4' : 'w-full my-6' ]">
    <div class="border-gray-200 dark:border-gray-800 flex-grow" :class="[ vertical ? 'border-r h-full' : 'border-b' ]" />
    <p v-if="text" class="px-4 leading-none">
      {{ text }}
    </p>
    <div v-if="text" class="border-b border-gray-200 dark:border-gray-800 flex-grow" />
  </div>
</template>

<script lang="ts">
export default { name: 'ODivider' }
</script>

<script setup lang="ts">
interface Props {
  text?: string | null
  vertical?: boolean
}

withDefaults(defineProps<Props>(), {
  text: null,
  vertical: false,
})
</script>
